import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import {
  EmailValidator,
  invalidEmailMessage,
  requiredFieldValidationMessage,
  SharedModule
} from '@app/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { NgxElectronModule } from 'ngx-electron';
import { NgxsModule } from '@ngxs/store';
import { SettingsState } from '@app/shared/settings/settings.state';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectComponent } from '@app/shared/formly/formly-select/formly-select.component';
import { FormlyInputComponent } from '@app/shared/formly/formly-input/formly-input.component';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { FormlyAutocompleteComponent } from '@app/shared/formly/formly-autocomplete/formly-autocomplete.component';
import { config } from '@app/app.config';
import { environment } from '@env/environment';
import { MatTooltipModule } from '@angular/material/tooltip';
console.log('config', config);


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AuthModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    GraphQLModule,
    HttpClientModule,
    SocketIoModule.forRoot({ url: config.socketIOURL, options: {transports: ['websocket']}}),
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    NgxElectronModule,
    MatFileUploadModule,
    MatTooltipModule,
    NgxsModule.forRoot([SettingsState], {
      developmentMode: !environment.production
    }),
    // NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsStoragePluginModule.forRoot({ key: ['settings'] }),
    FormlyModule.forRoot({
      validators: [
        {
          name: 'email',
          validation: EmailValidator
        }
      ],
      validationMessages: [
        { name: 'required', message: requiredFieldValidationMessage },
        { name: 'email', message: invalidEmailMessage }
      ],
      types: [
        {
          name: 'input',
          component: FormlyInputComponent,
          defaultOptions: { templateOptions: { hideRequiredMarker: true } }
        },
        {
          name: 'select',
          component: FormlySelectComponent,
          defaultOptions: {
            templateOptions: { hideRequiredMarker: true, valuePrimitive: true }
          }
        },
        {
          name: 'autocomplete',
          component: FormlyAutocompleteComponent

        }
      ]
    }),
    SharedModule
  ],
  providers: [
//     {
//       provide: ErrorHandler,
//       useValue: Sentry.createErrorHandler({
//         showDialog: false,
//         logErrors: true
//       })
//     },
//     {
//     provide: Sentry.TraceService,
//     deps: [Router],
//     useValue: undefined
// },
//     {
//       provide: APP_INITIALIZER,
//       useFactory: () => () => {
//       },
//       deps: [Sentry.TraceService],
//       multi: true
//     }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
